import { WebRTC } from '@medicusunion/webrtc-web';
import axios from 'axios';
import config from 'config';
import socket from 'services/socket';
import { USER_ID } from 'constants/voip';

const instance = axios.create({
  baseURL: config.meeting_api_url
});

const webrtc = new WebRTC({
  instance,
  userId: USER_ID,
  socket
});

export default webrtc;
